import { ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';

export function useDeleteActions(emit) {
  const store = useStore();
  const isComponentActive = ref(true);

  const isDeleteModalOpen = ref(false);
  const deleteType = ref('schedule'); // 'schedule' | 'campaign'
  const isDeleting = ref(false); // Estado de loading para a operação

  const handleDeleteSchedule = () => {
    if (!isComponentActive.value) return;

    deleteType.value = 'schedule';
    isDeleteModalOpen.value = true;
  };

  const handleDeleteCampaign = () => {
    if (!isComponentActive.value) return;

    deleteType.value = 'campaign';
    isDeleteModalOpen.value = true;
  };

  const confirmDelete = async rowInfo => {
    if (!isComponentActive.value || !rowInfo || isDeleting.value) {
      return;
    }

    isDeleting.value = true;

    try {
      if (deleteType.value === 'schedule') {
        const scheduleId = parseInt(rowInfo.scheduleId);
        const campaignId = rowInfo.campaignId;

        await store.dispatch('campaigns/deleteScheduling', {
          campaignId: campaignId,
          schedulingId: scheduleId,
        });

        useAlert('Agendamento deletado com sucesso!');

        if (isComponentActive.value && emit && typeof emit === 'function') {
          emit('deleteSchedule', scheduleId);
        }
      } else if (deleteType.value === 'campaign') {
        const campaignId = rowInfo.campaignId;

        const result = await store.dispatch('campaigns/delete', campaignId);

        if (result?.async) {
          useAlert(
            'Exclusão da campanha iniciada. Você será notificado quando concluir.'
          );
        } else if (result?.partial) {
          useAlert(
            result.message ||
              'Agendamentos pendentes deletados. Histórico mantido.'
          );
        } else {
          useAlert('Campanha deletada com sucesso!');
        }

        if (isComponentActive.value && emit && typeof emit === 'function') {
          emit('deleteCampaign', campaignId);
        }
      }

      if (isComponentActive.value) {
        isDeleteModalOpen.value = false;
      }
    } catch (error) {
      console.error('[useDeleteActions] Erro:', error);

      const errorMessage =
        deleteType.value === 'schedule'
          ? 'Erro ao deletar agendamento. Tente novamente.'
          : 'Erro ao deletar campanha. Tente novamente.';

      useAlert(errorMessage);
    } finally {
      isDeleting.value = false;
    }
  };

  const cancelDelete = () => {
    if (!isComponentActive.value) return;

    isDeleteModalOpen.value = false;
  };

  const cleanup = () => {
    isComponentActive.value = false;
    isDeleteModalOpen.value = false;
    deleteType.value = 'schedule';
    isDeleting.value = false;
  };

  // Auto cleanup quando o componente for desmontado
  onBeforeUnmount(() => {
    cleanup();
  });

  return {
    // Estados
    isDeleteModalOpen,
    deleteType,
    isDeleting,

    // Actions
    handleDeleteSchedule,
    handleDeleteCampaign,
    confirmDelete,
    cancelDelete,

    // Utilities
    cleanup,
  };
}
